import { useId, useState } from "react";
import { createPortal } from "react-dom";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import useItemDialogFocus from "../useItemDialogFocus";
import { getUnitName, unitSearchText } from "../../utils/unitNames";
import "./ItemClassificationPicker.css";

export default function ItemUnitPicker({ triggerId, label, value, units, onChange, disabled, optional = false, t }) {
  const { themeId, languageId } = usePmsTheme();
  const id = useId();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const close = () => setOpen(false);
  const dialogRef = useItemDialogFocus(open, false, close);
  const selected = units.find((unit) => String(unit.id) === String(value));
  const options = units.filter((unit) => unitSearchText(unit).toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()));
  const choose = (nextValue) => { onChange(nextValue); close(); };

  return <>
    <span className="spx-label" id={`${id}-label`}>{label}</span>
    <button type="button" id={triggerId} className="spx-input" aria-labelledby={`${id}-label ${id}-value`} aria-haspopup="dialog" aria-expanded={open}
      disabled={disabled} onClick={() => { setQuery(""); setOpen(true); }}>
      <span id={`${id}-value`}>{getUnitName(selected, languageId) || (value ? `#${value}` : t("Select unit"))}</span>
    </button>
    {open && !disabled && createPortal(
      <div className="pilcore-purchasing-ui icp-overlay" data-theme={themeId} onClick={(event) => { event.stopPropagation(); if (event.target === event.currentTarget) close(); }}>
        <section className="icp-dialog" ref={dialogRef} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1}>
          <header><h3>{label}</h3><button type="button" className="icp-button" onClick={close}>{t("Close")}</button></header>
          <div className="icp-content">
            <input type="search" aria-label={t("Search options…")} placeholder={t("Search options…")} value={query} onChange={(event) => setQuery(event.target.value)} />
            <div className="icp-cards">
              {optional && <button type="button" className="icp-card" onClick={() => choose("")}>{t("None")}</button>}
              {options.map((unit) => <button type="button" className="icp-card" key={unit.id} aria-pressed={String(unit.id) === String(value)} onClick={() => choose(String(unit.id))}>
                <strong>{getUnitName(unit, languageId)}</strong>{unit.code && <small>{unit.code}</small>}
              </button>)}
            </div>
            {!options.length && <p role="status">{t("No matching options.")}</p>}
          </div>
        </section>
      </div>, document.body
    )}
  </>;
}
